import { ssformatTime } from "@/utils/date-utils.js";
import { getToken } from "@/utils/auth";
// import des from '@/utils/des.js';
import store from "@/store";
import { mathJsonSha } from "@/utils/jsonSha256.js";

export function signData(send) {
  // console.log("33333333333333333");
  if (!send) {
    send = {};
  }

  let date = new Date();
  let ssDate = ssformatTime(date);
  send.txnReqTime = ssDate;

  if (store.getters.token) {
    send.token = store.getters.token;
  }

  // sha256Key = des.CalDES(MacKey, '77CE1A1B5FB09FAE765DDB84276B36AC', "D");
  //前端不加密签名
  // send.Sign = mathJsonSha(send, "1wcyz5wmr6rq23c353xe", 1);
  // console.log("sendsendsendsendsendsend", send);
  return send;
}

export function Loading(me) {
  return me.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  // return loading
}



// WEBPACK FOOTER //
// ./src/utils/sign-cfg.js